// extracted by mini-css-extract-plugin
export default {"stat":"Github_stat__b-4lH","one":"Github_one__dla9r","two":"Github_two__pFWur","three":"Github_three__ZWB6f","github":"Github_github__cxmIs"};